/**
 * LockUnlock — the DomiOps O-ring used as the auth status mark.
 * mode:
 *   "locked" → ring holds still (password / 2FA not yet accepted)
 *   "once" | "loop" → the arc spins at the brand's constant speed (accepted)
 * Same geometry as the wordmark's O so it reads as the logo, not a spinner.
 */
export default function LockUnlock({ size = 96, mode = "loop", className = "", "data-testid": testId = "lock-unlock" }) {
  const moving = mode !== "locked";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      data-testid={testId}
      data-state={moving ? "moving" : "still"}
      role="img"
      aria-label={moving ? "Accepted" : "Locked"}
    >
      <circle cx="50" cy="50" r="42.5" fill="none" stroke="#1d1d1f" strokeOpacity="0.2" strokeWidth="15" />
      <g style={{ transformOrigin: "50% 50%", animation: moving ? "domiops-spin 1.4s linear infinite" : "none" }}>
        <circle
          cx="50" cy="50" r="42.5" fill="none" stroke="#1d1d1f" strokeWidth="15" strokeLinecap="round"
          strokeDasharray="160 107" transform="rotate(-90 50 50)"
        />
      </g>
      <style>{`@keyframes domiops-spin { to { transform: rotate(360deg); } }`}</style>
    </svg>
  );
}
